export default __webpack_public_path__ + "static/media/info_noti.02fb1b8d.svg";